import { render, staticRenderFns } from "./RememberPasswordForm.vue?vue&type=template&id=c2b7fd7e"
import script from "./RememberPasswordForm.vue?vue&type=script&lang=js"
export * from "./RememberPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports